import React, { useState, useEffect } from "react";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import LocalityList from "../../components/Locality/LocalityList";
import LocalityFormModal from "../../components/Locality/LocalityFormModal";
import ListPagination from "../../components/Common/ListPagination";
import * as LocalityActions from "../../store/actions/Locality";
import Permission from "../../components/Common/Permission";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import { getPath } from "../../utils";
import FilterButton from "../../components/Common/FilterButton";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import { useHistory, useParams } from "react-router";

const Locality = (props) => {
  const params = useParams();
  const history = useHistory();
  const [modalState, setModalState] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const allActions = MenuActionsMappings[MenuNames.LOCALITY];

  const filterFields = ["locality.city_id", "locality.locality_name"];
  const shouldRenderList =
    getPath(params, "id", undefined) === undefined ? true : false;

  const handleClick = (type, id) => {
    setModalState(type);
    setActiveId(id);
  };

  const handleClose = () => {
    setModalState(false);
    setActiveId("");
    props.resetState({ state: "activeLocality" });
    if (history.location.pathname !== "/localities") {
      history.push("/localities");
    }
  };

  // handle pagination
  const handleNavClick = (action) => {
    const pageRequest = { page: currentPage };
    if (action === "prev") {
      pageRequest.page = currentPage - 1;
    } else {
      pageRequest.page = currentPage + 1;
    }
    setCurrentPage(pageRequest.page);
    props.getLocalityList(props.activeFilters, pageRequest);
  };

  const getModal = () => {
    const defaultProps = {
      activeId: activeId,
      modalState: modalState,
      handleClose: handleClose,
      cityList: props.cityList,
    };

    switch (modalState) {
      case "Add":
      case "Edit":
        return <LocalityFormModal {...defaultProps} />;
      case "Filter":
        return (
          <LocalityFormModal {...defaultProps} filterFields={filterFields} />
        );
      default:
        return;
    }
  };

  useEffect(() => {
    if (shouldRenderList === true) {
      props.getLocalityList();
    } else {
      handleClick("Edit", params.id);
    }
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(props.activeFilters)]);

  return (
    <div className="Locality-View container">
      <FlexContainer align="flex-start">
        <Heading>Localities</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.LIST]}>
            <FilterButton
              activeFilters={props.activeFilters}
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.CREATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="LocalitiesAddBtn"
            >
              Add New
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <Permission requiredPerms={[allActions.LIST]}>
        <LocalityList localityList={props.localityList} />
        <ListPagination
          nextPage={props.nextPage}
          prevPage={props.prevPage}
          handleNavClick={handleNavClick}
        />
      </Permission>
      {modalState && getModal()}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { Locality } = state;
  return {
    localityList: Locality.localityList,
    nextPage: Locality.nextPage,
    prevPage: Locality.prevPage,
    activeFilters: Locality.activeFilters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getLocalityList: bindActionCreators(
      LocalityActions.getLocalityList,
      dispatch
    ),
    resetState: bindActionCreators(LocalityActions.resetState, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Locality);
